import { render, staticRenderFns } from "./ModalLeave.vue?vue&type=template&id=03c60b00&"
import script from "./ModalLeave.vue?vue&type=script&lang=js&"
export * from "./ModalLeave.vue?vue&type=script&lang=js&"
import style0 from "./ModalLeave.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports